import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApi } from './client'
import type { ListResponse, Tag } from './types'

const ROOT = '/tags'
const KEY = ['tags'] as const

export function useTags() {
  const api = useApi()
  return useQuery({
    queryKey: KEY,
    queryFn: () => api<ListResponse<Tag>>(ROOT).then((r) => r.items),
  })
}

export type CreateTagInput = { name: string; color?: string | null }

export function useCreateTag() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateTagInput) => api<Tag>(ROOT, { method: 'POST', body: input }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}

export type UpdateTagInput = {
  id: string
  patch: Partial<{ name: string; color: string | null }>
}

export function useUpdateTag() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, patch }: UpdateTagInput) =>
      api<Tag>(`${ROOT}/${id}`, { method: 'PATCH', body: patch }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}

export function useDeleteTag() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api<void>(`${ROOT}/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}
